<template>
    <div class="wrapper">
        <div class="bg-wrapper">
            <div class="btn-group">
                <a href="javascript:void(0);" class="btn-donwload" @click="jumpTo"></a>
            </div>    
            <div class="store">
                <div class="store-element" @click="jumpToIos"><img src="../assets/images/distribution/4.png" alt=""></div>
                <div class="store-element" @click="jumpToAndriod"><img src="../assets/images/distribution/3.png" alt=""></div>
            </div>
        </div>    
    </div>
</template>
<style lang="less" scoped>
    .wrapper{
        background:#E2230F;
        height:100vh;
    }
    .bg-wrapper{
        width:10rem;
        height:17rem;
        background:#E2230F  url("../assets/images/distribution/6.jpg") no-repeat;
        background-size:100% 100%;                
        .store{
            display: flex;
            .store-element{
                width: 200px;
                height: 65px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .btn-group{
            padding-top: 900px;
            .btn-donwload{
                display: block;
                width:600px;
                height:150px;
                background:url("../assets/images/distribution/1.png") no-repeat;
                background-size:100%;
                margin:0 auto;
            }
        }
        .store{
            display: flex;
            justify-content: space-around;
            margin-top: 50px;
            .store-element{
                width: 300px;
                height: 100px;
            }
        }
    }
</style>
<script>
import { getOs } from '../../utils/tool';
import { buryv3 } from "../../api/index.js"
import { onMounted, ref } from 'vue'
export default {
   setup () {        
        const clicked = ref(false)
        onMounted(()=>{
            buryv3({
                "projectName":"distribution", 
                "pageName":"distribution",
                "behavior":"page_view",
                "value":"enter",
                "eventTime":""
            })
        })
        const jumpTo = () => {
            if(clicked.value)return
            clicked.value = true
            // buryv3({
            //     "projectName":"distribution", 
            //     "pageName":"distribution",
            //     "behavior":"click_download",
            //     "value":"clicked",
            //     "eventTime":""
            // })
            const os = getOs()
            if(os == 'ios-h5') {
                window.location.href = "https://rb.gy/jj6vl3"
            } else {
                window.location.href = "https://rb.gy/tu4vov"
            }
            clicked.value = false
        }
        const jumpToAndriod = () => {
            if(clicked.value)return
            clicked.value = true
            // buryv3({
            //     "projectName":"distribution", 
            //     "pageName":"distribution",
            //     "behavior":"click_download_android",
            //     "value":"clicked",
            //     "eventTime":""
            // })
            clicked.value = false
            window.location.href = "https://rb.gy/tu4vov"
        }
        const jumpToIos = () => {
            if(clicked.value)return
            clicked.value = true
            // buryv3({
            //     "projectName":"distribution", 
            //     "pageName":"distribution",
            //     "behavior":"click_download_ios",
            //     "value":"clicked",
            //     "eventTime":""
            // })
            clicked.value = false
            window.location.href = "https://rb.gy/jj6vl3"
        }
        return {
            jumpTo,
            jumpToIos,
            jumpToAndriod
        }
   } 
}
</script>